/*
 * ---------------------------------------------------------------------
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 WALC Inc. Inc. All Rights Reserved.
 *
 * file=app.ts
 *
 * This software is the confidential and proprietary information of WALC Inc.
 * (Confidential Information). You shall not disclose such Confidential Information
 * and shall use it only in accordance with the terms of the license agreement
 * you entered into with WALC Inc.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * <summary>: ルートコンポーネント。ヘッダーとルーティング先の画面を表示する。
 * ---------------------------------------------------------------------
 */


import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from './layout/header/header';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {}
